import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const DATE_LOCALE = "en-GB";
const DATE_TIME_ZONE = "Asia/Dubai";

export function formatCurrency(value, currency = "AED") {
  const amount = Number(value);
  const safeAmount = Number.isFinite(amount) ? amount : 0;

  return new Intl.NumberFormat("en-AE", {
    style: "currency",
    currency: currency || "AED",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(safeAmount);
}

function validDate(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDate(value) {
  const date = validDate(value);
  if (!date) return "—";

  return new Intl.DateTimeFormat(DATE_LOCALE, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: DATE_TIME_ZONE,
  }).format(date);
}

export function formatDateTime(value) {
  const date = validDate(value);
  if (!date) return "—";

  return new Intl.DateTimeFormat(DATE_LOCALE, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    timeZone: DATE_TIME_ZONE,
  }).format(date);
}
